export default "__VITE_ASSET__UkL0gs7t__"